var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationNoResults({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840.83 840.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3{fill:#d4d4f4;}.cls-3,.cls-8,.cls-9{opacity:0.5;}.cls-4{fill:#4c83f2;}.cls-5{fill:#211e96;}.cls-5,.cls-8{mix-blend-mode:multiply;}.cls-6{fill:#1c314f;}.cls-7{fill:#1b273a;mix-blend-mode:screen;}.cls-8{fill:#939292;}.cls-9{fill:#3b76bc;mix-blend-mode:overlay;}.cls-10{opacity:0.49;}.cls-11{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 421.67,
    cy: 420.42,
    r: 325.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 420.42,
    cy: 420.42,
    r: 420.42
  })), /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 581.66,
    y: 554.51,
    width: 50.85,
    height: 49.07,
    transform: "translate(1443.2 510.17) rotate(131.65)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "571.86 581.73 608.52 614.35 617.4 604.37 580.72 571.77 571.86 581.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 673.04,
    y: 556.16,
    width: 77.81,
    height: 232.26,
    rx: 9.31,
    transform: "translate(1687.43 587.02) rotate(131.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M632.15,587.27a14,14,0,0,1,19.48-.9L804.32,722.16a14,14,0,0,1,1.32,19.52l9.65-10.87a13.93,13.93,0,0,0-1.14-19.7L661.45,575.32a14,14,0,0,0-19.7,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M608.59,613.77l23.56-26.5a2.83,2.83,0,0,0-.24.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M609.75,633.47,762.44,769.26a14,14,0,0,0,19.71-1.16l11.47-12.91a14,14,0,0,1-19.52.95L621.4,620.36a14,14,0,0,1-1.32-19.52l-11.49,12.93A14,14,0,0,0,609.75,633.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "vidrio",
    className: "cls-9",
    cx: 425.34,
    cy: 419.19,
    r: 210.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M383.84,218.3C272.89,241.22,201.53,349.75,224.45,460.69S355.9,643,466.85,620.08s182.3-131.44,159.38-242.39S494.79,195.38,383.84,218.3m-7.1-34.38A239.55,239.55,0,1,1,289,221.34a238.75,238.75,0,0,1,87.77-37.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Brillo1",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M253.32,470.05A15,15,0,0,0,265,452.32c-18.27-88.42,38.81-175.23,127.23-193.5a15,15,0,1,0-6.07-29.37C281.52,251.06,214,353.77,235.6,458.39A15,15,0,0,0,253.32,470.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Brillo2",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M396.13,589.23a15,15,0,0,1,16.19-13.7c90,7.5,169.28-59.61,176.78-149.6a15,15,0,0,1,29.9,2.49c-8.87,106.47-102.7,185.87-209.17,177A15,15,0,0,1,396.13,589.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "sombra",
    className: "cls-5",
    d: "M382.81,213.3c113.71-23.5,224.94,49.64,248.43,163.35S581.59,601.59,467.88,625.09,242.94,575.44,219.45,461.73,269.09,236.79,382.81,213.3Zm84,406.78c110.94-22.92,182.3-131.44,159.38-242.39S494.79,195.38,383.84,218.3,201.53,349.75,224.45,460.69,355.9,643,466.85,620.08Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationNoResults);
export default __webpack_public_path__ + "static/media/Illustration_NoResults.09eaae5b587a7574b537972afbb535e2.svg";
export { ForwardRef as ReactComponent };